export enum BENEFIT_NAMES {
  greatFor = 'GreatFor',
  unlimitedInk = 'UnlimitedInk',
  prioritySupport = 'PrioritySupport',
}

export enum FEATURE_NAMES {
  modes = 'TrueCartridgePermanentPrinthead',
  auto2SidePrinting = 'AutoTwoSidePrinting',
  borderlessPhotos = 'BorderlessPhotos',
  autoDocumentFeeder = 'AutoDocumentFeeder',
  touchscreenPanel = 'TouchscreenPanel',
  fax = 'Fax',
  wideFormatPrinting = 'WideFormatPrinting',
  ethernetConnection = 'EthernetConnection',
  auto2SidedScanning = 'Auto2SidedScanning',
  printSpeed = 'IsoPrintSpeeds',
  paperTray = 'PaperTrayCapacity',
  wifiBandsSupported = 'WifiBandsSupported',
}
